var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3324 0.667648L19.9456 0.930292C19.9984 0.807744 20.0132 0.672177 19.9881 0.541132C19.963 0.410087 19.8991 0.289595 19.8048 0.195245C19.7104 0.100896 19.5899 0.0370318 19.4589 0.0119161C19.3278 -0.0131996 19.1923 0.00158914 19.0697 0.0543688L19.3324 0.667648ZM0.667322 8.66695L0.404679 8.05367C0.291626 8.10197 0.194134 8.1806 0.122982 8.28086C0.0518311 8.38112 0.00979198 8.49911 0.00151331 8.62177C-0.00676537 8.74443 0.0190389 8.867 0.076073 8.97591C0.133107 9.08482 0.219149 9.17584 0.324686 9.2389L0.667322 8.66695ZM11.3331 19.3327L10.7611 19.6753C10.8242 19.7808 10.9152 19.8669 11.0241 19.9239C11.133 19.981 11.2556 20.0068 11.3782 19.9985C11.5009 19.9902 11.6189 19.9482 11.7191 19.877C11.8194 19.8059 11.898 19.7084 11.9463 19.5953L11.3331 19.3327ZM19.0697 0.0543688L0.404679 8.05367L0.929966 9.28023L19.595 1.28093L19.0697 0.0543688ZM0.324686 9.2389L6.99077 13.2399L7.67604 12.096L1.00996 8.09633L0.324686 9.2389ZM6.76012 13.0092L10.7598 19.6753L11.9037 18.99L7.90402 12.324L6.76012 13.0092ZM11.945 19.5953L19.9443 0.930292L18.7177 0.405005L10.7184 19.07L11.945 19.5953ZM18.8604 0.197023L6.86145 12.196L7.80536 13.1386L19.8043 1.13961L18.8604 0.19569V0.197023Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.9ff65974298b9a7ab2e4ab8393795259.svg";
export { ForwardRef as ReactComponent };